// extracted by mini-css-extract-plugin
export default {"wrapper":"F8-z","play":"G8-z"};